var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.356 27.2592V18.2319H99.8475V27.2592H96.1186L90.4407 33.0749V15.7146H86.7966V2H86.2881V15.7146H82.5593V33.0749L76.8814 27.2592H73.1525V18.2319H72.6441V27.2592H69V50.6088H72.6441V63.2818H73.1525V50.6088H76.8814V36.8942L82.5593 42.7099V57.4661H86.2881V75H86.7966V57.4661H90.4407V42.7099L96.1186 36.8942V50.6088H99.8475V63.2818H100.356V50.6088H104V27.2592H100.356Z",
    fill: "#33CC66"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.f35ecdc879b8e7b41b5e7abb3bb3c4fe.svg";
export { ForwardRef as ReactComponent };